import { useMediaQuery, Box, Button } from "@mui/material";
import { useInViewport } from "react-in-viewport";

import slackIcon from "assets/slackIcon.svg";

import { Stack, SxProps } from "@mui/system";
import styles from "./styles";
import { useEffect, useRef, useState } from "react";
import { useAuthUrls } from "pages/signIn/SignInQueries";
import { useCurrentUser } from "app/appHooks";
export type IFeatureCardProps = {
  featureTitle: string;
  featureDescription: string;
  featureImg: string;
  featureBG?: string;
  featureImgFront?: string;
  featureImgRear?: string;
  frontStyle?: SxProps;
  rearStyle?: SxProps;
  cardDirection?: "row" | "row-reverse" | "column";
  featureAction?: "getStarted";
};

const GetStartedAction = () => {
  const { data, isLoading: isAuthURLsLoading, isSuccess } = useAuthUrls();
  const { data: user } = useCurrentUser();
  const classes = styles();

  return user ? null : (
    <Button
      disabled={isAuthURLsLoading || !isSuccess}
      className={classes.slackUrl}
      href={data?.slackAddtoURL}
    >
      <img
        alt="Add to Slack"
        className={classes.slackIcon}
        src={slackIcon}
        loading="lazy"
      />
      Add to Slack
    </Button>
  );
};
const featureActions = {
  getStarted: () => <GetStartedAction />
};

const FeatureCard = ({
  featureTitle,
  featureDescription,
  featureImg,
  cardDirection,
  featureBG,
  featureImgFront,
  featureImgRear,
  frontStyle,
  rearStyle,
  featureAction
}: IFeatureCardProps) => {
  const classes = styles();
  const isSM = useMediaQuery("(max-width:900px)");
  const myRef = useRef();
  const { inViewport } = useInViewport(myRef as any, {
    threshold: 0.3
  });
  const [imgAnimationClass, setImgAnimationClass] = useState(classes.hidden);
  const [textAnimationClass, setTextAnimationClass] = useState(classes.hidden);

  useEffect(() => {
    if (inViewport) {
      if (cardDirection === "row") {
        setImgAnimationClass(classes.getInRight);
        setTextAnimationClass(classes.getInLeft);
      } else {
        setImgAnimationClass(classes.getInLeft);
        setTextAnimationClass(classes.getInRight);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inViewport]);

  return (
    <Stack
      direction={cardDirection}
      sx={{
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: isSM ? "0" : "-70px"
      }}
    >
      <Stack
        direction={"row"}
        justifyContent="center"
        sx={{
          width: cardDirection === "column" ? "100%" : "50%"
        }}
      >
        <Stack
          className={textAnimationClass}
          direction={"column"}
          maxWidth={cardDirection === "column" ? undefined : "450px"}
        >
          <h3 className={classes.featureTitle}>{featureTitle}</h3>
          <p className={classes.featureDescription}>{featureDescription}</p>
          {!!featureAction ? featureActions[featureAction]() : null}
        </Stack>
      </Stack>
      <Box
        ref={myRef}
        sx={{
          position: "relative",
          width: { xs: "100%", md: "auto" }
        }}
      >
        {featureBG && featureImgFront && featureImgRear ? (
          <>
            <img
              src={featureBG}
              alt=""
              loading="lazy"
              className={classes.bubble}
            />
            <Box
              component={"img"}
              className={`${classes.rearImg} ${imgAnimationClass}`}
              src={featureImgRear}
              alt=""
              sx={{
                ...rearStyle
              }}
            />
            <Box
              component={"img"}
              className={`${classes.frontImg} ${imgAnimationClass}`}
              sx={{
                ...frontStyle,
                animationTimingFunction:
                  "cubic-bezier(0.24, 0.54, 0.62, 0.95) !important"
              }}
              src={featureImgFront}
              alt=""
            />
          </>
        ) : (
          <img
            className={imgAnimationClass}
            src={featureImg}
            alt={"feature card img"}
            width={isSM ? "100%" : undefined}
            loading="lazy"
          />
        )}
      </Box>
    </Stack>
  );
};

export default FeatureCard;
